<template>
    <div class="min-h-screen flex flex-col bg-gray-50">
      <!-- HERO SECTION APRIMORADA -->
      <section class="bg-gradient-to-b from-[#14336b] via-[#0a4da8] to-blue-500 text-white min-h-screen md:min-h-0 py-0 md:py-16 relative overflow-hidden flex flex-col justify-center">
        <canvas ref="waveCanvas" class="absolute top-0 left-0 w-full h-full z-0 pointer-events-none"></canvas>
        

  
        <div class="container mx-auto px-4 md:px-6 flex flex-col md:flex-row items-center justify-center gap-10 relative z-10 -mt-2 md:mt-0">
          <!-- BLOCO ESQUERDO APRIMORADO -->
          <div class="md:w-1/2 text-center md:text-left flex flex-col items-center md:items-start">
            <div class="  mb-6 inline-block">
              <img :src="Logo" alt="Logo" class="w-40 md:w-[280px] h-auto" />
            </div>
            <div class="md:flex space-x-4 mb-4">
              <img :src="LogoCircleWhite" alt="Saúde Pública Carioca" class="w-[320px] md:w-[600px] h-auto drop-shadow-lg" />
            </div>
            <h1 class="md:block text-sm md:text-3xl  font-bold mb-6 leading-tight">
            <span class="text-blue-200">Visualizador de imagens e laudos - CCDTI e Unidades Avançadas</span>
            </h1>
            
            

            <button @click="scrollToSection" class="bg-white text-[#14336b] px-6 py-3 rounded-lg font-medium hover:bg-blue-50 transition-colors flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                </svg>
                Ver Unidades
              </button>

          </div>
          
          <!-- BLOCO DIREITO (DECORATIVO) -->
          <div class="hidden md:block md:w-1/2 relative">
            <div class="absolute inset-0 flex items-center justify-center">
            </div>
          </div>
        </div>
  
        <!-- ANIMAÇÃO SETA APRIMORADA -->
        <div class="absolute bottom-4 inset-x-0 z-10 animate-bounce flex justify-center md:hidden">
          <button @click="scrollToSection" class="bg-white/10 backdrop-blur-sm p-3 rounded-full focus:outline-none hover:bg-white/20 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>
      </section>
  
      <!-- UNIDADES SECTION APRIMORADA -->
      <section id="unidades" class="py-4 md:py-4 bg-white relative bg-white">
        <!-- Elemento decorativo -->
        <div class="absolute hidden top-0 inset-x-0 h-16 bg-gradient-to-b from-gray-100 to-white"></div>
        
        <div class="container mx-auto px-4 md:px-6">
          <div class="max-w-3xl mx-auto text-center mb-4">
            <div class="inline-flex items-center  justify-center p-1 px-3 mb-2 border border-blue-900 rounded-full bg-blue-600/30 text-gray-800 text-sm font-medium">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              Nossas Unidades
            </div>
          </div>
          
          <!-- Estado de carregamento -->
          <div v-if="isLoading" class="flex flex-col items-center justify-center py-16">
            <div class="w-16 h-16 border-4 border-blue-200 border-t-[#005baa] rounded-full animate-spin mb-4"></div>
            <p class="text-gray-600 font-medium">Carregando unidades...</p>
          </div>
          
          <!-- Estado vazio -->
          <div v-else-if="unidades.length === 0" class="bg-blue-50 rounded-xl p-8 text-center max-w-2xl mx-auto">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mx-auto text-blue-300 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h3 class="text-xl font-semibold text-[#14336b] mb-2">Nenhuma unidade encontrada</h3>
            <p class="text-gray-600 mb-4">Não foi possível carregar as unidades no momento. Por favor, tente novamente mais tarde.</p>
            <button @click="carregarUnidades" class="bg-[#005baa] text-white px-4 py-2 rounded-lg hover:bg-[#004a8c] transition-colors">
              Tentar Novamente
            </button>
          </div>
          
          <!-- Lista de unidades -->
          <div v-else class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
            <div v-for="(unidade, index) in unidades" :key="index" 
                 class="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 group">
              <!-- Cabeçalho do card -->
              <div class="bg-gradient-to-r from-[#14336b] to-[#005baa] h-3 w-full"></div>
              
              <div class="p-6">
                <!-- Ícone e nome -->
                <div class="flex items-center mb-4">
                  <div class="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mr-4 text-[#005baa]">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                  </div>
                  <h3 class="text-xl font-semibold text-[#14336b] group-hover:text-[#005baa] transition-colors">
                    {{ unidade.nome }}
                  </h3>
                </div>
                
                <!-- Botões de acesso -->
                <div class="space-y-3 mt-6">


                  <a :href="unidade.works_url" target="_blank"
                     class="flex items-center justify-between bg-[#005baa] text-gray-100  py-3 px-4 rounded-lg hover:bg-blue-500 transition-colors w-full group">
                    <span class="font-medium">Acessar Portal</span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </a>  

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
    <!-- Footer -->
    <footer class="bg-[#14336B] text-white py-2 mt-auto">
      <div class="container mx-auto px-4 md:px-6">

        <!-- Logo centralizada -->
        <div class="flex justify-center mb-5">
          <img
            :src=LogoCircleWhite
            alt="Logo" class="w-[620px] md:w-[620px] h-auto" />
        </div>



        <!-- Rodapé final -->
        <div class="pt-2 text-center text-sm">
          <p>&copy; {{ new Date().getFullYear() }} Desenvolvido por Tecnologia da Informação - CCDTI © Todos os direitos reservados</p>
        </div>

      </div>
    </footer>


    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  
  import Logo from '@/assets/Logo.png';
  import LogoCircleWhite from '@/assets/LogoCircleWhite.png';
  
  const unidades = ref([]);
  const isLoading = ref(true);
  
  const carregarUnidades = async () => {
    isLoading.value = true;
    try {
      const response = await fetch('/api/v1/enterprises/unidades/links/');
      if (!response.ok) {
        throw new Error(`Erro HTTP ${response.status}`);
      }
      const data = await response.json();
      unidades.value = data
        .filter((unidade) => unidade.works_url)
        .sort((a, b) => a.nome.localeCompare(b.nome));
    } catch (err) {
      console.error('Erro ao buscar unidades:', err);
      unidades.value = [];
    } finally {
      isLoading.value = false;
    }
  };
  
  onMounted(async () => {
    // Inicializar canvas de ondas
    initWaveCanvas();
    
    // Carregar unidades
    await carregarUnidades();
  });
  
  const scrollToSection = () => {
    const section = document.getElementById('unidades');
    if (section) section.scrollIntoView({ behavior: 'smooth' });
  };
  
  // Implementação da animação de ondas no canvas
  const initWaveCanvas = () => {
    const canvas = document.querySelector('canvas');
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    
    const waves = {
      y: canvas.height / 2,
      length: 0.01,
      amplitude: 100,
      frequency: 0.01
    };
    
    const strokeColor = {
      h: 201,
      s: '100%',
      l: '100%',
      a: 0.20
    };
    
    let increment = waves.frequency;
    
    function animate() {
      requestAnimationFrame(animate);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      ctx.beginPath();
      ctx.moveTo(0, canvas.height / 2);
      
      for (let i = 0; i < canvas.width; i++) {
        ctx.lineTo(
          i, 
          waves.y + Math.sin(i * waves.length + increment) * waves.amplitude * Math.sin(increment)
        );
      }
      
      ctx.strokeStyle = `hsla(${strokeColor.h}, ${strokeColor.s}, ${strokeColor.l}, ${strokeColor.a})`;
      ctx.stroke();
      increment += waves.frequency;
    }
    
    animate();
    
    window.addEventListener('resize', () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    });
  };
  </script>
  
  <style scoped>
  /* Animações e transições */
  @keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-10px); }
    100% { transform: translateY(0px); }
  }
  
  .animate-float {
    animation: float 6s ease-in-out infinite;
  }
  
  /* Estilos para scrollbar personalizada */
  ::-webkit-scrollbar {
    width: 10px;
  }
  
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  
  ::-webkit-scrollbar-thumb {
    background: #005baa;
    border-radius: 5px;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #004a8c;
  }
  </style>
